import { createElement } from 'react'
import { FlagCell } from 'routes/shared/components'
import { Favorite } from './components/favoriteButton'

export const createColumns = () => [
  {
    Header: 'Team Name',
    accessor: 'teamDTO.teamName',
    minWidth: 200,
    width: 200,
  },

  {
    Header: 'Sport',
    accessor: 'teamDTO.sport',
  },
  {
    Header: 'Jurisdiction',
    accessor: 'teamDTO.jurisdiction.logo',
    Cell: FlagCell,
  },
  {
    Header: 'Team Website',
    accessor: 'teamDTO.teamWebsite',
  },
  {
    Header: 'Favorite',
    id: 'controls',
    width: 180,
    minWidth: 180,
    accessor: (value) => value,
    Cell: (props) => createElement(Favorite, { ...props }),
  },
]
